import { PROJECT_NAME } from 'consts/config';
import useTitle from 'react-use/lib/useTitle';

export const usePageTitle = (page?: string) => {
  useTitle(page ? `${PROJECT_NAME} | ${page}` : PROJECT_NAME);
};
